import React, { useState } from "react";
import UsingShopTableRow from "./UsingShopTableRow";
import { useEffect } from "react";
import { Box, FormHelperText } from "@mui/material";
import { isNullEmpty } from "../../../utils/validation";
import { searchShopInfoList } from "../../../http/api/CustomerAPI";

const UsingShopTable = ({ usingShops, onChangeShops, errors }) => {

  const [customerShops, setCustomerShops] = useState([]);

  useEffect(() => {
      fetchShopInfo();
  }, []);

  async function fetchShopInfo() {
    try {
      const response = await searchShopInfoList({});
      const shopList = response.data?.listShopInfo ?? response.listShopInfo;

      // map で shopNameが空なら、「本店」を表す
      const updatedShopList = shopList.map(shop => {
        if (shop.shopName === "　") { // 空白の名前を「本店」に変更
          return { ...shop, shopName: "本店" };
        }
        return shop;
      });
      setCustomerShops(updatedShopList);
    } catch (error) {
      console.error("Failed to fetch shop info:", error);
    }
  }

  const onClickPlusButton = (index) => () => {
    const newClient = { customerId: 0, shopId: 0 };

    const updatedList = [
      ...usingShops.slice(0, index + 1),
      newClient,
      ...usingShops.slice(index + 1)
    ];

    onChangeShops(updatedList);
  };

  const onClickMinusButton = (indexToRemove) => () => {
    if (usingShops.length == 1)
      return;

    const newUsingShopList = usingShops.filter((_, index) => index !== indexToRemove);
    onChangeShops(newUsingShopList);

  };

  const onChangeShopAtIndex = (index) => (shop) => {
    const updatedList = usingShops.map((item, idx) =>
      idx === index
        ? { ...item, ...shop}
        : item
    );

    onChangeShops(updatedList);
  };

  return (
    <div>
      {usingShops.map((shop, index) => (
        <Box 
          sx={{
            borderTop: index > 0 ? "1px solid lightgrey" : "none"
          }}
        >
          <UsingShopTableRow
            key={index + "marketPriceCustomerShop"}
            onClickPlusButton={onClickPlusButton(index)}
            onClickMinusButton={onClickMinusButton(index)}
            disabledMinusButton={usingShops.length < 2}
            shop={shop}
            index={index}
            onChangeShop={onChangeShopAtIndex(index)}
            errors={errors[index]}
            customerShops={customerShops}
          />
        </Box>
      ))}
    </div>
  );
};

export default UsingShopTable;

